export const CHUNK_SIZE = 8 * 1024 * 1024; // 8MB

export default function breakIntoChunks(fileSize) {
  const chunks = [];

  const numBlocks = Math.floor((fileSize - 1) / CHUNK_SIZE) + 1;

  for (let i = 0; i < numBlocks; i++) {
    const start = CHUNK_SIZE * i;
    const end = i === numBlocks - 1 ? fileSize : start + CHUNK_SIZE;
    const contentLength = end - start;

    chunks.push({
      chunkId: start,
      startPosition: start,
      endPosition: end,
      contentLength,
    });
  }

  const maxLength = `${chunks[chunks.length - 1].chunkId}z`.length;
  chunks.forEach((chunk) => {
    //need to make all the chunkIds the same length, otherwise blob storage gets angry
    chunk.chunkId = `${chunk.chunkId}`.padStart(maxLength, "0");
  });

  return chunks;
}
